export default __webpack_public_path__ + "static/media/cpv_70_makelaar.cf419502.svg";